import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { PropertyCode } from "src/types/property";

export const PROPERTY_CODE_LABELS: { [key in PropertyCode]: LocaleKeys } = {
  id: "page.rules.modal.create.simple.form.property.common.id",
  date: "page.rules.modal.create.simple.form.property.common.date",
  etape: "page.rules.modal.create.simple.form.property.common.etape",
  sous_etape: "page.rules.modal.create.simple.form.property.common.sous_etape",
  motif_refus: "page.rules.modal.create.simple.form.property.common.motif_refus",
  region: "page.rules.modal.create.simple.form.property.common.region",
  date_octroi: "page.rules.modal.create.simple.form.property.common.date_octroi",
  date_signature: "page.rules.modal.create.simple.form.property.common.date_signature",
  montant_demande: "page.rules.modal.create.simple.form.property.common.montant_demande",
  date_decaissement: "page.rules.modal.create.simple.form.property.common.date_decaissement",
  montant_decaisse: "page.rules.modal.create.simple.form.property.common.montant_decaisse",
  montant_regle_total: "page.rules.modal.create.simple.form.property.common.montant_regle_total",
  type_pret: "page.rules.modal.create.simple.form.property.common.type_pret",
  SIREN: "page.rules.modal.create.simple.form.property.common.SIREN",
  raison_sociale: "page.rules.modal.create.simple.form.property.common.raison_sociale",
  adresse_siege: "page.rules.modal.create.simple.form.property.common.adresse_siege",
  numera: "page.rules.modal.create.simple.form.property.common.numera",
  c_tiers: "page.rules.modal.create.simple.form.property.common.c_tiers",
  APE: "page.rules.modal.create.simple.form.property.common.APE",
  CODE_APE: "page.rules.modal.create.simple.form.property.common.CODE_APE",
  ca: "page.rules.modal.create.simple.form.property.common.ca",
  resultat_net: "page.rules.modal.create.simple.form.property.common.resultat_net",
  dette: "page.rules.modal.create.simple.form.property.common.dette",
  capital_social: "page.rules.modal.create.simple.form.property.common.capital_social",
  ratio: "page.rules.modal.create.simple.form.property.common.ratio",
  IBAN_decaissement: "page.rules.modal.create.simple.form.property.common.IBAN_decaissement",
  type_banque: "page.rules.modal.create.simple.form.property.common.type_banque",
  nom_banque: "page.rules.modal.create.simple.form.property.common.nom_banque",
  date_creation: "page.rules.modal.create.simple.form.property.common.date_creation",
  pef_is_same_bpi_address:
    "page.rules.modal.create.simple.form.property.common.pef_is_same_bpi_address",
  pef_is_same_bpi_address_description:
    "page.rules.modal.create.simple.form.property.common.pef_is_same_bpi_address_description",
  nom: "page.rules.modal.create.simple.form.property.common.nom",
  prenom: "page.rules.modal.create.simple.form.property.common.prenom",
  email: "page.rules.modal.create.simple.form.property.common.email",
  test_id: "page.rules.modal.create.simple.form.property.common.test_id",
  email_formulaire: "page.rules.modal.create.simple.form.property.common.email_formulaire",
  telephone: "page.rules.modal.create.simple.form.property.common.telephone",
  telephone_formulaire: "page.rules.modal.create.simple.form.property.common.telephone_formulaire",
  nombre_echeances_impaye:
    "page.rules.modal.create.simple.form.property.common.nombre_echeances_impaye",
  impayes_30jours: "page.rules.modal.create.simple.form.property.common.impayes_30jours",
  impayes_90jours: "page.rules.modal.create.simple.form.property.common.impayes_90jours",
  nombre_passages_impaye:
    "page.rules.modal.create.simple.form.property.common.nombre_passages_impaye",
  montant_impaye_capital:
    "page.rules.modal.create.simple.form.property.common.montant_impaye_capital",
  montant_impaye_interets:
    "page.rules.modal.create.simple.form.property.common.montant_impaye_interets",
  montant_impaye_accessoires:
    "page.rules.modal.create.simple.form.property.common.montant_impaye_accessoires",
  montant_impaye_interets_retard:
    "page.rules.modal.create.simple.form.property.common.montant_impaye_interets_retard",
  date_passage_en_perte:
    "page.rules.modal.create.simple.form.property.common.date_passage_en_perte",
  montant_passe_en_pertes:
    "page.rules.modal.create.simple.form.property.common.montant_passe_en_pertes",
  pfe_siren: "page.rules.modal.create.simple.form.property.common.pfe_siren",
  pfe_date_creation: "page.rules.modal.create.simple.form.property.common.pfe_date_creation",
  pfe_nom_entreprise: "page.rules.modal.create.simple.form.property.common.pfe_nom_entreprise",
  pfe_code_naf: "page.rules.modal.create.simple.form.property.common.pfe_code_naf",
  pfe_libelle_code_naf: "page.rules.modal.create.simple.form.property.common.pfe_libelle_code_naf",
  pfe_date_premiere_immatriculation_rcs:
    "page.rules.modal.create.simple.form.property.common.pfe_date_premiere_immatriculation_rcs",
  pfe_procedure_collective_existe:
    "page.rules.modal.create.simple.form.property.common.pfe_procedure_collective_existe",
  pfe_procedure_collective_en_cours:
    "page.rules.modal.create.simple.form.property.common.pfe_procedure_collective_en_cours",
  pfe_entreprise_cessee:
    "page.rules.modal.create.simple.form.property.common.pfe_entreprise_cessee",
  pfe_date_cessation: "page.rules.modal.create.simple.form.property.common.pfe_date_cessation",
  pfe_statut_rne: "page.rules.modal.create.simple.form.property.common.pfe_statut_rne",
  pfe_date_radiation_rne:
    "page.rules.modal.create.simple.form.property.common.pfe_date_radiation_rne",
  pfe_status: "page.rules.modal.create.simple.form.property.common.pfe_status",
  pfe_error_status: "page.rules.modal.create.simple.form.property.common.pfe_error_status",
  pfe_execution_date: "page.rules.modal.create.simple.form.property.common.pfe_execution_date",
  application: "page.rules.modal.create.simple.form.property.common.application",
  depense_carburant: "page.rules.modal.create.simple.form.property.common.depense_carburant",
  previsionnel_carburant:
    "page.rules.modal.create.simple.form.property.common.previsionnel_carburant",
  forme_juridique: "page.rules.modal.create.simple.form.property.common.forme_juridique",
  forme_juridique_libelle:
    "page.rules.modal.create.simple.form.property.common.forme_juridique_libelle",
  capitaux_propres: "page.rules.modal.create.simple.form.property.common.capitaux_propres",
  resultat_exploitation:
    "page.rules.modal.create.simple.form.property.common.resultat_exploitation",
  ratio_dettes_capital: "page.rules.modal.create.simple.form.property.common.ratio_dettes_capital",
  ratio_dettes_capitaux_propres:
    "page.rules.modal.create.simple.form.property.common.ratio_dettes_capitaux_propres",
  date_immatriculation: "page.rules.modal.create.simple.form.property.common.date_immatriculation",
  same_addresses: "page.rules.modal.create.simple.form.property.common.same_addresses",
  same_addresses_description:
    "page.rules.modal.create.simple.form.property.common.same_addresses_description",
  adresse: "page.rules.modal.create.simple.form.property.common.adresse",
  ip: "page.rules.modal.create.simple.form.property.common.ip",
  date_naissance: "page.rules.modal.create.simple.form.property.common.date_naissance",
  ville_naissance: "page.rules.modal.create.simple.form.property.common.ville_naissance",
  pays_naissance: "page.rules.modal.create.simple.form.property.common.pays_naissance",
  onFncRfList: "page.rules.modal.create.simple.form.property.common.onFncRfList",
  alertId: "page.rules.modal.create.simple.form.property.common.alertId",
  createdAt: "page.rules.modal.create.simple.form.property.common.createdAt",
  createdBy: "page.rules.modal.create.simple.form.property.common.createdBy",
  alertQualification: "page.rules.modal.create.simple.form.property.common.alertQualification",
  reportsCount: "page.rules.modal.create.simple.form.property.common.reportsCount",
  reportsQualified: "page.rules.modal.create.simple.form.property.common.reportsQualified",
  reportsSightings: "page.rules.modal.create.simple.form.property.common.reportsSightings",
  reportsFalsePositives:
    "page.rules.modal.create.simple.form.property.common.reportsFalsePositives",
  fraudCategory: "page.rules.modal.create.simple.form.property.common.fraudCategory",
  transactionType: "page.rules.modal.create.simple.form.property.common.transactionType",
  fraudSource: "page.rules.modal.create.simple.form.property.common.fraudSource",
  transactionChannel: "page.rules.modal.create.simple.form.property.common.transactionChannel",
  accountClosed: "page.rules.modal.create.simple.form.property.common.accountClosed",
  reports: "page.rules.modal.create.simple.form.property.common.reports",
  ibanSeen: "page.rules.modal.create.simple.form.property.common.ibanSeen",
  ibanMinAge: "page.rules.modal.create.simple.form.property.common.ibanMinAge",
  whitelistedParty: "page.rules.modal.create.simple.form.property.common.whitelistedParty",
  status: "page.rules.modal.create.simple.form.property.common.status",
  errorStatus: "page.rules.modal.create.simple.form.property.common.errorStatus",
  executionDate: "page.rules.modal.create.simple.form.property.common.executionDate",
  pays_immatriculation: "page.rules.modal.create.simple.form.property.common.pays_immatriculation",
  profession: "page.rules.modal.create.simple.form.property.common.profession",
  adresse_domicile: "page.rules.modal.create.simple.form.property.common.adresse_domicile",
  adresse_pro: "page.rules.modal.create.simple.form.property.common.adresse_pro",
  ca_liasse_fiscale: "page.rules.modal.create.simple.form.property.common.ca_liasse_fiscale",
  ca_declare: "page.rules.modal.create.simple.form.property.common.ca_declare",
  revenu_annuel: "page.rules.modal.create.simple.form.property.common.revenu_annuel",
  patrimoine_global: "page.rules.modal.create.simple.form.property.common.patrimoine_global",
  origine_patrimoine: "page.rules.modal.create.simple.form.property.common.origine_patrimoine",
  origine_fonds: "page.rules.modal.create.simple.form.property.common.origine_fonds",
  type_banque_decaissement:
    "page.rules.modal.create.simple.form.property.common.type_banque_decaissement",
  nom_banque_decaissement:
    "page.rules.modal.create.simple.form.property.common.nom_banque_decaissement",
  IBAN_encaissement: "page.rules.modal.create.simple.form.property.common.IBAN_encaissement",
  type_banque_encaissement:
    "page.rules.modal.create.simple.form.property.common.type_banque_encaissement",
  nom_banque_encaissement:
    "page.rules.modal.create.simple.form.property.common.nom_banque_encaissement",
};
